<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>商品列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item>
        <el-input size="small" v-model="formInline.goodName" placeholder="输入商品名称"></el-input>
      </el-form-item>
      <el-form-item label="商品专区" prop="goodType">
        <el-select v-model="formInline.goodType" placeholder="请选择商品专区" @change="clickType">
            <el-option label="算力专区" value="0"></el-option>
            <el-option label="普通专区" value="1"></el-option>
            <el-option label="本地专区" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column  align="center" prop="goodName" label="商品名称" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column  align="center" prop="typeName" label="商品类型" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column  align="center" prop="beforeGoodPrize" label="原价" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column  align="center" prop="goodPrize" label="商品价格" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column  align="center" prop="goodImg" label="商品图片" width="140" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-image
            v-if="scope.row.goodImg != null"
            :src="scope.row.goodImg[0]"
            style="width: 100px;height: 100px;"
          />
        </template>
      </el-table-column>
      <el-table-column  align="center" prop="goodType" label="商品专区" width="120" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.goodType == 0?'算力专区':scope.row.goodType == 1?'普通专区':'本地专区' }}</span>
        </template>
      </el-table-column>
      <el-table-column  align="center" prop="isGood" label="推荐商品" width="120" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.isGood == 0?'否':'是' }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column  align="center" prop="goodTitle" label="商品详情" width="180" show-overflow-tooltip>
        <template slot-scope="scope">
            <div v-html="scope.row.goodTitle"></div>
        </template>
      </el-table-column> -->
      <el-table-column  align="center" prop="status" label="商品状态" width="140" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{scope.row.status == 0?'正常':'已删除'}}</div>
        </template>
      </el-table-column>
      
      <el-table-column align="center" label="操作" min-width="150">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">修改</el-button>
          <el-button size="mini" type="danger" @click="deleteUser(1, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    
  </div>
</template>

<script>
import { getGoodsList, unloadAddGoods, OrderDelete } from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '预览',
      editForm: {
        id: '',
        name: '',
        payType: 1,
        partner: '',
        subMchId: '',
        appid: '',
        notifyUrl: '',
        signType: '',
        partnerKey: '',
        sellerUserId: '',
        certPath: '',
        certPassword: '',
        rsaKey: '',
        token: localStorage.getItem('logintoken')
      },
      formInline: {
        page: 1,
        limit: 10,
        goodName: '',
        goodType: ''
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },
  filters: {
    filterData(val) {
        let newVal = JSON.parse(val);
        return newVal[0]
    }
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    clickType(e) {
      this.formInline.goodType = e;
      this.getdata(this.formInline);
    },
    // 获取公司列表
    getdata(parameter) {
      this.loading = true
      getGoodsList(parameter)
        .then(res => {
          this.loading = false
          if (res.success == false) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.data
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.num
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('菜单加载失败，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
        this.$router.push({
            path: './AddGoods',
            query: {
                goData: row
            }
        })
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          ConfigSave(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.success) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '公司保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('支付配置信息保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // 删除公司
    deleteUser(val, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
            unloadAddGoods({del: val,goodId:row.id})
            .then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '商品已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/pay/Goods.vue